import { putChannel } from '../../services/api/channel.api';
import { UPDATE_CHANNEL_REQUEST, UPDATE_CHANNEL_SUCCESS, UPDATE_CHANNEL_FAILURE } from '../types';
import { transformError } from '../../transforms/error';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
	},

	mutations: {
		[UPDATE_CHANNEL_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
		},
		[UPDATE_CHANNEL_SUCCESS](state) {
			state.isLoading = false;
		},
		[UPDATE_CHANNEL_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async updateChannel({ commit }, { id, params }) {
			try {
				commit(UPDATE_CHANNEL_REQUEST);
				await putChannel(id, params);
				commit(UPDATE_CHANNEL_SUCCESS);
			} catch (error) {
				commit(UPDATE_CHANNEL_FAILURE, error);
			}
		},
	},
};